import * as React from 'react';
/**
 * @ignore - internal component.
 */
const RadioGroupContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}
export default RadioGroupContext;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/RadioGroup/RadioGroupContext.js
// module id = 872
// module chunks = 22